<template>
    <card card-body-classes="table-full-width">
        <v-data-table id="paymentsTable"
                      :headers="headers" :search="searchQuery"
                      :items="payments" :loading="isLoadingPayments"
                      item-key="invoiceID" :pagination.sync="paginationSync"
                      show-summary data-app
        >
            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
            <template slot="items" slot-scope="props">
                <tr>
                    <td class="text-left">{{ props.item.date }}</td>
                    <td class="text-left">{{ props.item.type }}</td>
                    <td class="text-right">{{ props.item.amount }} {{ $store.getters['customer/currency'] }}</td>
                </tr>
            </template>
        </v-data-table>
    </card>
</template>

<script>
    import {Option, Select, Table, TableColumn} from 'element-ui';
    import {BasePagination} from 'src/components';
    import Fuse from 'fuse.js';
    import Badge from "../../components/Badge";
    import Modal from "../../components/Modal";

    export default {
        name: "PaymentsTable",
        components: {
            Modal,
            Badge,
            BasePagination,
            [Select.name]: Select,
            [Option.name]: Option,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn
        },
        computed: {
            payments() {
                return this.$store.getters['billing/payments'];
            },
            isLoadingPayments() {
                return this.$store.getters['billing/isLoading'];
            },
        },
        data() {
            return {
                paginationSync: {
                    rowsPerPage: 10,
                    descending: true,
                    sortBy: 'date',
                },
                propsToSearch: ['date', 'amount'],
                searchedData: [],
                searchQuery: '',
                fuseSearch: null,
                loading: [],
                headers: [
                    {text: 'Date', value: 'date', sortable: true, align: 'left'},
                    {text: 'Method', value: 'type', sortable: true, align: 'center'},
                    {text: 'Total', value: 'amount', align: 'right'},
                ],
                paymentLoading: [],
            };
        },
        methods: {},

        mounted() {
            if (this.$store.getters['billing/needUpdate']) {
                this.$store.dispatch('billing/loadPayments');
            }

            // Fuse search initialization.
            this.fuseSearch = new Fuse(this.payments, {
                keys: ['id', 'date', 'amount', 'type'],
                threshold: 0.3
            });

        },
        watch: {
            /**
             * Searches through the table data by a given query.
             * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
             * @param value of the query
             */
            searchQuery(value) {
                let result = this.payments;
                if (value !== '') {
                    result = this.fuseSearch.search(this.searchQuery);
                }
                this.searchedData = result;
            }
        }
    }
</script>
<style>
    .pagination-select,
    .search-input {
        width: 200px;
    }

    .el-input__inner {
        padding-left: 30px !important;
    }

    tr.warning {
        background-color: rgba(249, 97, 97, 0.38)
    }
</style>
